import type { NotificationComponentProps } from './Notification';
import type { MessageOptions } from '../message';
import type { NotificationKind } from './types.old';

export interface OldNotificationComponentProps extends Omit<NotificationComponentProps, 'status' | 'closable'> {
  /** @deprecated status를 대신 사용해주세요. */
  kind?: NotificationKind;
  /** @deprecated closable을 대신 사용해주세요. */
  closeButton?: boolean;
}

export function convertOldNotificationProps(props: OldNotificationComponentProps): NotificationComponentProps {
  const { kind, closeButton, ...restProps } = props;

  return {
    ...restProps,
    status: kind,
    closable: closeButton,
  };
}

export function convertOldNotificationOptions(
  props: MessageOptions<OldNotificationComponentProps>,
): MessageOptions<NotificationComponentProps> {
  const { kind, closeButton, ...restProps } = props;

  return {
    ...restProps,
    status: kind,
    closable: closeButton,
  };
}
